/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-use-before-define */
import axios from 'axios';
import { IFootballMatch } from '../../interfaces/interfaces';
import { BASE_URL } from '../../config/config';

export const getMatches = async (
  language: string,
  competitionId: string,
  seasonId: string
): Promise<IFootballMatch[]> => {
  const { data: matches } = await axios.get(
    `${BASE_URL}/football/matches/competition/${competitionId}/season/${seasonId}?status=all&language=${language}&limit=500`
  );
  return matches;
};
